import axios from 'axios'

const ListService = {
  async getRoles (params = {}) {
    return axios.get('shared/list/roles', { params })
  },

  async getActiveRoles (params = {}) {
    return this.getRoles({ is_active: 1, ...params })
  },

  async getStudents (params = {}) {
    return axios.get('shared/list/students', { params })
  },

  async getActiveStudents (params = {}) {
    return this.getStudents({ is_active: 1, ...params })
  },

  async getSystemOptions (params = {}) {
    return axios.get('shared/list/system-options', { params })
  },

  async getAppointmentConcernTypes (params = {}) {
    return axios.get('shared/list/appointment-concern-types', { params })
  },

  async getActiveAppointmentConcernTypes (params = {}) {
    return this.getAppointmentConcernTypes({ is_active: 1, ...params })
  },

  async getAppointmentSlots (params = {}) {
    return axios.get('shared/list/appointment-slots', { params })
  },

  async getViolationTypes (params = {}) {
    return axios.get('shared/list/violation-types', { params })
  },

  async getActiveViolationTypes (params = {}) {
    return this.getViolationTypes({ is_active: 1, ...params })
  },

  async getLfItemCategories (params = {}) {
    return axios.get('shared/list/lf-item-categories', { params })
  },

  async getActiveLfItemCategories (params = {}) {
    return this.getLfItemCategories({ is_active: 1, ...params })
  },

  async getLfItems (params = {}) {
    return axios.get('shared/list/lf-items', { params })
  },

  async getActiveLfItems (params = {}) {
    return this.getLfItems({ is_active: 1, ...params })
  },

  async getResourceCategories (params = {}) {
    return axios.get('shared/list/resource-categories', { params })
  },

  async getActiveResourceCategories (params = {}) {
    return this.getResourceCategories({ is_active: 1, ...params })
  },

  async getResources (params = {}) {
    return axios.get('shared/list/resources', { params })
  },

  async getActiveResources (params = {}) {
    return this.getResources({ is_active: 1, ...params })
  },

  async getUsers (params = {}) {
    return axios.get('shared/list/users', { params })
  },

  async getStudentResidences (params = {}) {
    return axios.get('shared/list/student-residences', { params })
  }
}

export default ListService
